<template>
  <v-layout column justify-space-between>
    <v-layout row wrap justify-space-between>
      <v-flex xs12 md6 grow class="pa-2">
        <ClientActivityCenter />
      </v-flex>

      <v-flex xs12 md6 grow class="pa-2">
        <v-card class="item-list" style="height: 100%; display: flex; flex-direction: column;">
            <ClientTabs />
            <!-- <h1 class="text-xs-center mb-3 subtle all-caps">Current Shifts</h1> -->
            
            <v-layout shrink flex align-center justify-space-between row class="pa-2 pr-4">
              <v-btn to="/service/new" color=success>
                <v-icon>add</v-icon>
                Add Shift
              </v-btn>
              <router-link :to="{ name: 'calendar' }">
                View Staffing >
              </router-link>
            </v-layout>
        </v-card>
      </v-flex>
    </v-layout>

    <ClientManagerWidget v-for="manager in managers" :manager="manager" />

  </v-layout>
</template>

<script>
import { mapState } from 'vuex'

import ClientManagerWidget from '@/components/dashboard/client-manager-widget.vue'
import managerApi from '@/api/manager'
import shiftApi from '@/api/shift'
import ClientActivityCenter from '@/components/dashboard/client-activity-center.vue'
import ClientTabs from '@/components/dashboard/client-tabs.vue'
import TimeClock from '@/components/dashboard/time-clock.vue'
import AvailableShifts from '@/components/dashboard/available-shifts.vue'
import ShiftItem from '@/components/dashboard/shift-item.vue'

export default {
  components: {
    ClientManagerWidget,
    ClientActivityCenter,
    ClientTabs,
    TimeClock,
    AvailableShifts,
    ShiftItem,
  },
  computed: {
    ...mapState('userAuth', [
      'user',
    ]),
  },
  created () {
    this.setUp()
  },
  watch: {
  },
  data: function () {
    return {
      managers: [],
    }
  },
  methods: {
    setUp () {
      this.getManager()
      this.setOffShiftChecker()
    },
    getManager () {
      managerApi.managerOf(this.user.id, managers => {
        this.managers = managers
      },
      error => {
        console.log(error)
      })
    },
    setOffShiftChecker () {
      this.getCurrentShifts()
      let interval = 600000 // every 10 minutes
      this.shiftGetter = setInterval(function() {
        this.getCurrentShifts()
      }.bind(this), interval)
    },
    getCurrentShifts() {
      this.gettingShifts = true
      shiftApi.getCurrentForClient(this.user.id, shifts => {
        this.currentShifts = shifts
        this.gettingShifts = false
      },
      error => {
        console.log(error)
        this.gettingShifts = true
      })
    },
  },
}
</script>

<style scoped>
#dashboard-container {
}
</style>
